export default __webpack_public_path__ + "static/media/ncx-logo.6671638c.svg";